import { Link } from 'react-router-dom';
import styles from './sectionTitle.module.css';


export default function SectionTitle(props) {
  const { title = '', button = '', className = '', titleClassName = '', btnClassName = '', style = {}, titleStyle = {}, btnStyle = {}, to = '#' } = props;

  return (
    <div className={`${styles.container} ${className} textBlackBlue`} style={style}>
      <h2 className={`${styles.title} ${titleClassName} h2 fw-bold`} style={titleStyle}>
        {title}
        <img className={styles.image} src="/assets/images/sectionTitle/dotted.png" alt='dotted background' />
      </h2>
      {button && <Link className={btnClassName} style={btnStyle} to={to}>{button}</Link>}
    </div>
  )
}
